import { Alert, AlertDescription } from "@capacit-com/lara-law-shared-ui";
import type { ExplorerSelectionEntry } from "@/lib/buildConversationWorkspaceDocuments";
import {
  countDedupedDocumentsInExplorerSelection,
  MAX_CONVERSATION_WORKSPACE_DOCUMENT_SNAPSHOTS,
} from "@/lib/buildConversationWorkspaceDocuments";

type Props = {
  selectedItems: ExplorerSelectionEntry[];
};

/** Shown above the workspace explorer so users see the 2000-document cap while selecting. */
export const WorkspaceContextCapBanner = ({ selectedItems }: Props) => {
  const contextDocCount =
    countDedupedDocumentsInExplorerSelection(selectedItems);
  const atContextLimit =
    contextDocCount >= MAX_CONVERSATION_WORKSPACE_DOCUMENT_SNAPSHOTS;

  return (
    <Alert variant={atContextLimit ? "destructive" : "default"}>
      <AlertDescription className="text-sm">
        Dokumenter i kontekst: {contextDocCount} /{" "}
        {MAX_CONVERSATION_WORKSPACE_DOCUMENT_SNAPSHOTS}.
        {atContextLimit ? " Fjern dokumenter før du tilføjer flere." : null}
      </AlertDescription>
    </Alert>
  );
};
